import { create } from "zustand";

interface NavCollapseState {
  // Señales de origen: quién está pidiendo espacio.
  aiDocked: boolean; // chat de Fluxi AI acoplado (lo setea ChatLayoutWrapper)
  lensActive: boolean; // Modo Lente de Métricas (lo setea DashboardWithTabs)
  // Derivados que consume el layout global:
  collapsed: boolean; // nav en modo rail de íconos (80px) = aiDocked || lensActive
  hidden: boolean; // nav desaparece por completo = Lente + IA a la vez (la barra
  // blanca superior con el logo es el camino de regreso)
  setAiDocked: (aiDocked: boolean) => void;
  setLensActive: (lensActive: boolean) => void;
}

// El Lente persiste en sessionStorage: si la página recarga con él activo, el
// nav debe NACER colapsado. Sin esta lectura síncrona, el primer paint sale
// con el nav ancho (240px) y el contenido queda cortado bajo el panel hasta
// que los efectos alcancen a correr.
const lensRestoredActive = (() => {
  try {
    const raw = sessionStorage.getItem("metrics_lens");
    return raw ? JSON.parse(raw)?.state?.active === true : false;
  } catch {
    return false;
  }
})();

// Señal global para colapsar el nav lateral. El nav es global, NO de Finance:
// estas señales solo las activa Métricas (IA acoplada y/o Modo Lente); por
// defecto son `false`, así el resto de la app se comporta igual que siempre.
export const useNavCollapse = create<NavCollapseState>((set) => ({
  aiDocked: false,
  lensActive: lensRestoredActive,
  collapsed: lensRestoredActive,
  hidden: false,
  setAiDocked: (aiDocked) =>
    set((state) => ({
      aiDocked,
      collapsed: aiDocked || state.lensActive,
      hidden: aiDocked && state.lensActive,
    })),
  setLensActive: (lensActive) =>
    set((state) => ({
      lensActive,
      collapsed: state.aiDocked || lensActive,
      hidden: state.aiDocked && lensActive,
    })),
}));
